module.exports = __webpack_public_path__ + "static/media/traffic-sources.df33e6f3.jpg";